/* src/app/private/components/course/delete-course/delete-course.component.scss */
/*# sourceMappingURL=delete-course.component.css.map */
